
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.add-to-cart');

  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // カートページにリダイレクト
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('カートへの追加に失敗しました:', error);
      });
    });
  });
});

